var React = require('react');

function Pointer (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.97735 13.1557L11.7482 19.0979C11.9038 19.4316 11.7595 19.8282 11.4258 19.9838L9.00895 21.1108C8.67525 21.2664 8.2786 21.1221 8.123 20.7884L5.28909 14.711L1.80473 18.1954C1.6797 18.3204 1.51013 18.3907 1.33332 18.3907C0.965133 18.3907 0.666656 18.0922 0.666656 17.724V0.840499C0.666656 0.674655 0.728471 0.514766 0.840029 0.392051C1.0877 0.119613 1.50933 0.0995348 1.78177 0.347206L14.1899 11.6273C14.3157 11.7417 14.3931 11.8999 14.4062 12.0695C14.4344 12.4366 14.1597 12.7571 13.7926 12.7853L8.97735 13.1557Z","fill":"#2D63D7"}));
}

Pointer.defaultProps = {"width":"15","height":"22","viewBox":"0 0 15 22","fill":"none"};

module.exports = Pointer;

Pointer.default = Pointer;
